import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { mockAlerts, Alert } from "@/lib/mockData";
import { cn } from "@/lib/utils";

const getAlertStyle = (type: Alert['type']) => {
  switch (type) {
    case 'warning':
      return 'bg-warning/10 text-warning border-warning/20 hover:bg-warning/20';
    case 'success':
      return 'bg-success/10 text-success border-success/20 hover:bg-success/20';
    case 'info':
      return 'bg-primary/10 text-primary border-primary/20 hover:bg-primary/20';
    default:
      return 'bg-muted text-muted-foreground';
  }
};

export function AlertsCard() {
  return (
    <Card className="col-span-2 hover:shadow-lg transition-all duration-200 border-0 shadow-md">
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <span>🤖</span>
          <span>AI Predictive Alerts</span>
        </CardTitle>
        <CardDescription>
          Smart insights about your spending patterns
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {mockAlerts.map((alert) => (
            <div
              key={alert.id}
              className={cn(
                "flex items-start space-x-3 p-3 rounded-lg border transition-colors duration-200",
                getAlertStyle(alert.type)
              )}
            >
              <span className="text-lg flex-shrink-0">{alert.icon}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium leading-relaxed">
                  {alert.message}
                </p>
              </div>
              <Badge 
                variant="outline" 
                className={cn(
                  "ml-auto flex-shrink-0 text-xs",
                  alert.type === 'warning' && 'border-warning/50 text-warning',
                  alert.type === 'success' && 'border-success/50 text-success',
                  alert.type === 'info' && 'border-primary/50 text-primary'
                )}
              >
                {alert.type}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}